import React from 'react'
import { shallow } from 'enzyme'
import Dashboard from '../features/dashboard/Dashboard'

describe('<Dashboard />', () => {
  let wrapper, instance
  beforeEach(() => {
    global.window.localStorage = {
      setItem(key, value) {
        this[key] = `${value}`
      },
      getItem(key) {
        return this[key]
      }
    }
  })
  describe('#toggleSort', () => {
    describe('when the current page is a number other than one', () => {
      beforeEach(() => {
        wrapper = shallow(<Dashboard />)
        instance = wrapper.instance()
        wrapper.setState({ page: 10 })
      })
      it('should reset to page one', () => {
        instance.toggleSort()
        expect(wrapper.state('page')).toEqual(1)
      })
    })
    describe('when sort order is ascending', () => {
      beforeEach(() => {
        wrapper = shallow(<Dashboard />)
        instance = wrapper.instance()
        wrapper.setState({ order: 'asc' })
      })
      it('should change the sort order to descending', () => {
        instance.toggleSort()
        expect(wrapper.state('order')).toEqual('desc')
      })
    })
    describe('when sort order is descending', () => {
      beforeEach(() => {
        wrapper = shallow(<Dashboard />)
        instance = wrapper.instance()
        wrapper.setState({ order: 'desc' })
      })
      it('should change the sort order to ascending', () => {
        instance.toggleSort()
        expect(wrapper.state('order')).toEqual('asc')
      })
    })
  })
  describe('#getPerPage', () => {
    describe('when geniePerPage does not exist in localStorage', () => {
      beforeEach(() => {
        wrapper = shallow(<Dashboard />)
        instance = wrapper.instance()
      })
      it('should return 10', () => {
        expect(instance.getPerPage()).toEqual(10)
      })
    })
    describe('when geniePerPage is defined in localStorage', () => {
      let storedPerPage
      beforeEach(() => {
        wrapper = shallow(<Dashboard />)
        instance = wrapper.instance()
        storedPerPage = 50
        localStorage.setItem('geniePerPage', storedPerPage)
      })
      it('should return the stored value', () => {
        expect(instance.getPerPage()).toEqual(storedPerPage)
      })
    })
  })
  describe('#changePerPage', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
      localStorage.setItem('geniePerPage', undefined)
    })
    it('should update the component\'s state with the new per page value', () => {
      const newPerPage = 20
      instance.changePerPage(newPerPage)
      expect(wrapper.state('perPage')).toEqual(newPerPage)
    })
    it('should update localStorage with the new per page value', () => {
      const newPerPage = 30
      instance.changePerPage(newPerPage)
      expect(localStorage.getItem('geniePerPage')).toEqual(newPerPage.toString())
    })
  })
  describe('#changeRole', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    it('should update the component\'s state with the new role value', () => {
      const newRole = 'AM'
      instance.changeRole(newRole)
      expect(wrapper.state('role')).toEqual(newRole)
    })
  })
  describe('#changePage', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    it('should update the component\'s state with the new page value', () => {
      const newPage = 5
      instance.changePage(newPage)
      expect(wrapper.state('page')).toEqual(newPage)
    })
  })
  describe('#next', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    it('should increment the component\'s `page` state property by one', () => {
      const currentPage = wrapper.state('page')
      instance.next()
      expect(wrapper.state('page')).toEqual(currentPage + 1)
    })
  })
  describe('#prev', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    it('should decrement the component\'s `page` state property by one if it is greater than one', () => {
      const currentPage = 4
      wrapper.setState({ page: currentPage })
      instance.prev()
      expect(wrapper.state('page')).toEqual(currentPage - 1)
    })
    it('should do nothing if decrementing the component\'s `page` state property would produce a value less than one', () => {
      const currentPage = 1
      wrapper.setState({ page: currentPage })
      instance.prev()
      expect(wrapper.state('page')).toEqual(currentPage)
    })
  })
  describe('#first', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    it('should change the component\'s `page` state value to 1', () => {
      wrapper.setState({ page: 4 })
      instance.first()
      expect(wrapper.state('page')).toEqual(1)
    })
  })
  describe('#onHeaderClick', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    describe('when sortBy is a category other than the header that is clicked', () => {
      beforeEach(() => {
        wrapper.setState({ sortBy: 'value' })
      })
      it('should change its sortBy state property to the new category', () => {
        const newCategory = 'leftUntilCap'
        instance.onHeaderClick(newCategory)
        expect(wrapper.state('sortBy')).toEqual(newCategory)
      })
      it('should change the sort order to `desc`', () => {
        wrapper.setState({ order: 'asc' })
        instance.onHeaderClick('leftUntilCap')
        expect(wrapper.state('order')).toEqual('desc')
      })
    })
    describe('when sortBy is the same category as the header that is clicked', () => {
      beforeEach(() => {
        wrapper.setState({ sortBy: 'value' })
      })
      describe('when the sort order is `asc`', () => {
        beforeEach(() => {
          wrapper.setState({ order: 'asc' })
        })
        it('should change the sort order to `desc`', () => {
          instance.onHeaderClick('value')
          expect(wrapper.state('order')).toEqual('desc')
        })
      })
      describe('when the sort order is `desc`', () => {
        beforeEach(() => {
          wrapper.setState({ order: 'desc' })
        })
        it('should change the sort order to `asc`', () => {
          instance.onHeaderClick('value')
          expect(wrapper.state('order')).toEqual('asc')
        })
      })
    })
  })
  describe('#render', () => {
    beforeEach(() => {
      wrapper = shallow(<Dashboard />)
      instance = wrapper.instance()
    })
    it('should return something', () => {
      expect(instance.render()).toBeTruthy()
    })
  })
})
